import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  "type": "datetime",
  "name": "Date & Time",
  "category": "utilities",
  "description": "Work with dates and times - format, parse, calculate",
  "icon": "Calendar",
  "color": "gray",
  "version": "1.2.0",
  "group": [
    "transform"
  ],
  "defaults": {
    "name": "Date & Time",
    "color": "#6b7280"
  },
  "inputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Input",
      "required": true
    }
  ],
  "outputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Output"
    }
  ],
  "tags": [
    "date",
    "time",
    "datetime",
    "format",
    "parse",
    "calendar"
  ]
};

export default definition;
